export enum NewInvestmentOrderStatus {
  IDLE = 'IDLE',
  CREATING_ORDER = 'CREATING_ORDER',
  CREATING_ORDER_SUCCEEDED = 'CREATING_ORDER_SUCCEEDED',
  CREATING_ORDER_FAILED = 'CREATING_ORDER_FAILED',
  AUTHORIZING_ORDER = 'AUTHORIZING_ORDER',
  AUTHORIZING_ORDER_SUCCEEDED = 'AUTHORIZING_ORDER_SUCCEEDED',
  AUTHORIZING_ORDER_FAILED = 'AUTHORIZING_ORDER_FAILED',
  CONFIRMING_ORDER = 'CONFIRMING_ORDER',
  CONFIRMING_ORDER_SUCCEEDED = 'CONFIRMING_ORDER_SUCCEEDED',
  CONFIRMING_ORDER_FAILED = 'CONFIRMING_ORDER_FAILED'
}
